import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=0e28c4f8&scoped=true"
import script from "./activityInfo.vue?vue&type=script&lang=js"
export * from "./activityInfo.vue?vue&type=script&lang=js"
import style0 from "./activityInfo.vue?vue&type=style&index=0&id=0e28c4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28c4f8",
  null
  
)

export default component.exports